import { useMutation, useQueryClient } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';
import { FindRunningChargePointsQueryKey } from '@services/queries/use-find-running-charge-points.query.ts';
import { FindChargePointDetailsQueryKey } from '@services/queries/use-find-charge-point-details.query.ts';

export const RestartChargePointMutationKey = 'restart-charge-point';

interface RestartChargePointData {
  cpid: string;
}

export const useRestartChargePoint = () => {
  const queryClient = useQueryClient();

  return useMutation(
    RestartChargePointMutationKey,
    async ({ cpid }: RestartChargePointData) => {
      await apiCpService.restartClientCpClientCpidRestartPost(cpid);
    },
    {
      onSuccess: (_data, { cpid }) => {
        void queryClient.invalidateQueries(FindRunningChargePointsQueryKey);
        void queryClient.invalidateQueries([FindChargePointDetailsQueryKey, cpid]);
      },
    },
  );
};
